import React from 'react';

const ElegantSalesInvoice = ({
    data,
    invoiceData,
    selectedPaymentType = 'Debit',
    selectedInvoiceType = 'TAX INVOICE',
    selectedCopyType = 'Original',
    getImageUrl
}) => {
    const chunkArray = (array, size) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    };

    const itemChunks = invoiceData.items && invoiceData.items.length > 0
        ? chunkArray(invoiceData.items, 15)
        : [[]];

    const borderColor = '#cbd5e1'; 
    const bgColor = '#f8fafc';
    const textColor = '#0f172a';
    const fontFamily = '"Times New Roman", Times, serif';

    return (
        <div className="invoice-pages-container" style={{ display: 'flex', flexDirection: 'column', gap: '20px', fontFamily, color: textColor }}>
            {itemChunks.map((chunk, pageIndex) => {
                const company = data?.Company || data?.companyId || data?.company || {};

                return (
                    <div className="invoice-box" key={pageIndex} style={{ color: textColor, fontSize: '10px', background: '#fff', width: '800px', margin: '0 auto', boxSizing: 'border-box', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                        {(() => {
                            const headerImg = company?.company_letter_head_header_image || company?.companyLetterHeadHeaderImage;
                            if (headerImg) {
                                return (
                                    <div className="header-image-container" style={{ borderBottom: `1.5px solid ${borderColor}`, paddingBottom: '10px', marginBottom: '15px' }}>
                                        <img 
                                            src={getImageUrl(headerImg)} 
                                            alt="Header" 
                                            crossOrigin="anonymous"
                                            style={{ width: '100%', height: 'auto', display: 'block' }} 
                                        />
                                    </div>
                                );
                            }
                            return null;
                        })()}
                        
                        {/* Top Header Section */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                            <div style={{ width: '200px' }}>
                                {!(company?.company_letter_head_header_image || company?.companyLetterHeadHeaderImage) && (
                                    <div className="header-image-container">
                                        <h2 style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
                                            {company?.company_name || data?.invoiceCompanyName || data?.companyName || 'COMPANY NAME'}
                                        </h2>
                                        <div style={{ fontSize: '8px', color: '#64748b', marginTop: '2px', lineHeight: '1.3' }}>
                                            {company?.company_address || data?.invoiceCompanyAddress || data?.companyAddress || ''}
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                            <div style={{ textAlign: 'center', flex: 1 }}>
                                <h1 style={{ margin: '0 0 8px 0', fontSize: '22px', fontWeight: 'bold', letterSpacing: '1px' }}>
                                    {selectedInvoiceType}
                                </h1>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', fontSize: '11px' }}>
                                    <span><strong>Invoice No:</strong> {invoiceData.invoiceNo}</span>
                                    <span><strong>Date:</strong> {invoiceData.invoiceDate}</span>
                                    <span><strong>Place:</strong> {invoiceData.buyer.placeOfSupply} ({invoiceData.buyer.stateCode})</span>
                                </div>
                            </div>
                            
                            <div style={{ width: '200px', textAlign: 'right', fontSize: '10px', color: '#64748b' }}>
                                {selectedCopyType} Copy
                            </div>
                        </div>

                        {/* 3 Columns Section: Buyer, Ship To, Transport */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                            {/* Buyer */}
                            <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ padding: '6px 10px', borderBottom: `1.5px solid ${borderColor}`, background: bgColor, fontWeight: 'bold', fontSize: '11px' }}>
                                    BUYER DETAILS
                                </div>
                                <div style={{ padding: '10px', lineHeight: '1.5' }}>
                                    <strong style={{ fontSize: '12px' }}>{invoiceData.buyer.name}</strong><br/>
                                    {invoiceData.buyer.address} {invoiceData.buyer.cityState}<br/>
                                    <strong>GSTIN:</strong> {invoiceData.buyer.gstin}
                                </div>
                            </div>
                            
                            {/* Ship To */}
                            <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ padding: '6px 10px', borderBottom: `1.5px solid ${borderColor}`, background: bgColor, fontWeight: 'bold', fontSize: '11px' }}>
                                    SHIP TO
                                </div>
                                <div style={{ padding: '10px', lineHeight: '1.5' }}>
                                    <strong style={{ fontSize: '12px' }}>{invoiceData.consignee.name}</strong><br/>
                                    {invoiceData.consignee.address} {invoiceData.consignee.cityState}<br/>
                                    <strong>PAN:</strong> {invoiceData.consignee.pan || 'N/A'}<br/>
                                    <strong>State Code:</strong> {invoiceData.consignee.stateCode}
                                </div>
                            </div>
                            
                            {/* Transport */}
                            <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ padding: '6px 10px', borderBottom: `1.5px solid ${borderColor}`, background: bgColor, fontWeight: 'bold', fontSize: '11px' }}>
                                    TRANSPORT
                                </div>
                                <div style={{ padding: '10px', lineHeight: '1.5' }}>
                                    <strong>Mode:</strong> {selectedPaymentType}<br/>
                                    <strong>L/R:</strong> {invoiceData.lrNo || 'N/A'} {invoiceData.lrDate ? `(${invoiceData.lrDate})` : ''}<br/>
                                    <strong>Vehicle:</strong> {invoiceData.vehicleNo || 'N/A'}<br/>
                                    <strong>Container:</strong> {invoiceData.containerNo || 'N/A'} | <strong>Seal:</strong> {invoiceData.sealNo || 'N/A'}<br/>
                                    <strong>E-Way Bill:</strong> {invoiceData.eWayBillNo || 'N/A'}
                                </div>
                            </div>
                        </div>

                        {/* Items Table */}
                        <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', overflow: 'hidden', marginBottom: '15px' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center', fontSize: '10px' }}>
                                <thead>
                                    <tr style={{ background: bgColor, borderBottom: `1.5px solid ${borderColor}` }}>
                                        <th style={{ padding: '8px 4px', borderRight: `1.5px solid ${borderColor}` }}>SR</th>
                                        <th style={{ padding: '8px 4px', borderRight: `1.5px solid ${borderColor}`, textAlign: 'left' }}>DESCRIPTION</th>
                                        <th style={{ padding: '8px 4px', borderRight: `1.5px solid ${borderColor}` }}>MODEL/SIZE</th>
                                        <th style={{ padding: '8px 4px', borderRight: `1.5px solid ${borderColor}` }}>HSN</th>
                                        <th style={{ padding: '8px 4px', borderRight: `1.5px solid ${borderColor}` }}>GRADE</th>
                                        <th style={{ padding: '8px 4px', borderRight: `1.5px solid ${borderColor}` }}>QTY</th>
                                        <th style={{ padding: '8px 4px', borderRight: `1.5px solid ${borderColor}`, textAlign: 'right' }}>RATE</th>
                                        <th style={{ padding: '8px 4px', textAlign: 'right' }}>AMOUNT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((item, i) => (
                                        <tr key={i} style={{ borderBottom: `1.5px solid ${borderColor}` }}>
                                            <td style={{ padding: '6px 4px', borderRight: `1.5px solid ${borderColor}` }}>{item.srNo}</td>
                                            <td style={{ padding: '6px 4px', borderRight: `1.5px solid ${borderColor}`, textAlign: 'left' }}>
                                                <strong>{item.product}</strong>
                                                {item.category && <div style={{ color: '#64748b', fontSize: '9px' }}>({item.category} {item.color ? `| ${item.color}` : ''})</div>}
                                            </td>
                                            <td style={{ padding: '6px 4px', borderRight: `1.5px solid ${borderColor}` }}>{item.model}</td>
                                            <td style={{ padding: '6px 4px', borderRight: `1.5px solid ${borderColor}` }}>{item.hsn}</td>
                                            <td style={{ padding: '6px 4px', borderRight: `1.5px solid ${borderColor}` }}>{item.grade}</td>
                                            <td style={{ padding: '6px 4px', borderRight: `1.5px solid ${borderColor}` }}>{item.qty} {item.unit || ''}</td>
                                            <td style={{ padding: '6px 4px', borderRight: `1.5px solid ${borderColor}`, textAlign: 'right' }}>{item.rate}</td>
                                            <td style={{ padding: '6px 4px', textAlign: 'right' }}>{item.amount}</td>
                                        </tr>
                                    ))}
                                    
                                    {/* Fill empty space if chunk is small */}
                                    {chunk.length < 5 && (
                                        <tr style={{ height: `${(5 - chunk.length) * 30}px` }}>
                                            <td style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td></td>
                                        </tr>
                                    )}

                                    {/* Totals Section */}
                                    <tr style={{ borderTop: `1.5px solid ${borderColor}` }}>
                                        <td colSpan={6} style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                        <td style={{ padding: '6px 8px', textAlign: 'right', borderRight: `1.5px solid ${borderColor}` }}>Taxable Amount</td>
                                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{invoiceData.totals.taxableAmount}</td>
                                    </tr>
                                    {parseFloat(invoiceData.totals.discount) > 0 && (
                                        <tr style={{ borderTop: `1.5px solid ${borderColor}` }}>
                                            <td colSpan={6} style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ padding: '6px 8px', textAlign: 'right', borderRight: `1.5px solid ${borderColor}`, color: '#dc2626' }}>Discount</td>
                                            <td style={{ padding: '6px 8px', textAlign: 'right', color: '#dc2626' }}>-{invoiceData.totals.discount}</td>
                                        </tr>
                                    )}
                                    {parseFloat(invoiceData.totals.insurance) > 0 && (
                                        <tr style={{ borderTop: `1.5px solid ${borderColor}` }}>
                                            <td colSpan={6} style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ padding: '6px 8px', textAlign: 'right', borderRight: `1.5px solid ${borderColor}` }}>Insurance</td>
                                            <td style={{ padding: '6px 8px', textAlign: 'right' }}>{invoiceData.totals.insurance}</td>
                                        </tr>
                                    )}
                                    {parseFloat(invoiceData.totals.extra) > 0 && (
                                        <tr style={{ borderTop: `1.5px solid ${borderColor}` }}>
                                            <td colSpan={6} style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ padding: '6px 8px', textAlign: 'right', borderRight: `1.5px solid ${borderColor}` }}>{invoiceData.extraChargesName || data?.extraChargesName || 'Extra Charges'}</td>
                                            <td style={{ padding: '6px 8px', textAlign: 'right' }}>{invoiceData.totals.extra}</td>
                                        </tr>
                                    )}
                                    
                                    {/* Taxes */}
                                    {invoiceData.totals.isLocal ? (
                                        <>
                                            <tr style={{ borderTop: `1.5px solid ${borderColor}` }}>
                                                <td colSpan={6} style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                                <td style={{ padding: '6px 8px', textAlign: 'right', borderRight: `1.5px solid ${borderColor}` }}>CGST ({invoiceData.totals.tax1Rate}%)</td>
                                                <td style={{ padding: '6px 8px', textAlign: 'right' }}>{invoiceData.totals.tax1}</td>
                                            </tr>
                                            <tr style={{ borderTop: `1.5px solid ${borderColor}` }}>
                                                <td colSpan={6} style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                                <td style={{ padding: '6px 8px', textAlign: 'right', borderRight: `1.5px solid ${borderColor}` }}>SGST ({invoiceData.totals.tax2Rate}%)</td>
                                                <td style={{ padding: '6px 8px', textAlign: 'right' }}>{invoiceData.totals.tax2}</td>
                                            </tr>
                                        </>
                                    ) : (
                                        <tr style={{ borderTop: `1.5px solid ${borderColor}` }}>
                                            <td colSpan={6} style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                            <td style={{ padding: '6px 8px', textAlign: 'right', borderRight: `1.5px solid ${borderColor}` }}>IGST ({invoiceData.totals.tax1Rate + invoiceData.totals.tax2Rate}%)</td>
                                            <td style={{ padding: '6px 8px', textAlign: 'right' }}>{invoiceData.totals.totalTax}</td>
                                        </tr>
                                    )}

                                    {/* Grand Total */}
                                    <tr style={{ borderTop: `1.5px solid ${borderColor}`, background: bgColor, fontWeight: 'bold' }}>
                                        <td colSpan={6} style={{ borderRight: `1.5px solid ${borderColor}` }}></td>
                                        <td style={{ padding: '8px', textAlign: 'right', borderRight: `1.5px solid ${borderColor}` }}>Grand Total</td>
                                        <td style={{ padding: '8px', textAlign: 'right' }}>{invoiceData.totals.grandTotal}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Amount in Words */}
                        <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', padding: '8px 15px', textAlign: 'right', fontWeight: 'bold', marginBottom: '15px', fontSize: '11px' }}>
                            Amount in Words: {invoiceData.totals.words.toUpperCase()}
                        </div>

                        {/* Footer Info Grid */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                            <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ padding: '6px 10px', borderBottom: `1.5px solid ${borderColor}`, background: bgColor, fontWeight: 'bold', fontSize: '11px' }}>
                                    BANK DETAILS
                                </div>
                                <div style={{ padding: '10px', lineHeight: '1.6' }}>
                                    <strong>Bank:</strong> {invoiceData.bank.name}<br/>
                                    <strong>A/c:</strong> {invoiceData.bank.accountNumber}<br/>
                                    <strong>IFSC:</strong> {invoiceData.bank.ifsc}
                                </div>
                            </div>
                            <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ padding: '6px 10px', borderBottom: `1.5px solid ${borderColor}`, background: bgColor, fontWeight: 'bold', fontSize: '11px' }}>
                                    COMPANY INFO
                                </div>
                                <div style={{ padding: '10px', lineHeight: '1.6' }}>
                                    <strong>GSTIN:</strong> {company?.company_gst_number || company?.companyGstNumber || 'N/A'}<br/>
                                    <strong>PAN:</strong> {company?.company_pan_card_number || 'N/A'}
                                </div>
                            </div>
                            <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', overflow: 'hidden' }}>
                                <div style={{ padding: '6px 10px', borderBottom: `1.5px solid ${borderColor}`, background: bgColor, fontWeight: 'bold', fontSize: '11px' }}>
                                    PAYMENT TERMS
                                </div>
                                <div style={{ padding: '10px', lineHeight: '1.6' }}>
                                    {invoiceData.paymentTerms || data?.paymentTerms || selectedPaymentType || 'N/A'}
                                </div>
                            </div>
                        </div>

                        {/* Terms and Signatures */}
                        <div style={{ border: `1.5px solid ${borderColor}`, borderRadius: '6px', overflow: 'hidden', marginBottom: '30px' }}>
                            <div style={{ padding: '6px 10px', borderBottom: `1.5px solid ${borderColor}`, background: bgColor, fontWeight: 'bold', fontSize: '11px' }}>
                                TERMS & CONDITIONS
                            </div>
                            <div style={{ padding: '10px', fontSize: '9px', lineHeight: '1.5', whiteSpace: 'pre-line' }}>
                                {data?.termsCondtion || '1. Goods Once Supplied will not be taken back or exchanged.\n2. We are not responsible for any shortage or damage in transit.\n3. Subject to jurisdiction.'}
                            </div>
                        </div>

                        {/* Signature Area */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 40px 20px 40px', marginTop: 'auto' }}>
                            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                <div style={{ width: '150px', borderBottom: '1.5px solid #000', marginBottom: '8px' }}></div>
                                <strong style={{ fontSize: '11px' }}>Receiver</strong>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <div className="auth-sign-img" style={{ minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px' }}>
                                    {(() => {
                                        const sigImg = company?.company_digital_signature || company?.companyDigitalSignature;
                                        if (sigImg) {
                                            return (
                                                <img
                                                    src={getImageUrl(sigImg)}
                                                    alt="Signature"
                                                    crossOrigin="anonymous"
                                                    style={{ maxHeight: '60px', maxWidth: '100%', objectFit: 'contain' }}
                                                />
                                            );
                                        }
                                        return <div style={{ width: '80px', height: '60px', border: `1.5px solid ${borderColor}` }}></div>;
                                    })()}
                                </div>
                                <div style={{ width: '200px', borderBottom: '1.5px solid #000', marginBottom: '8px' }}></div>
                                <strong style={{ fontSize: '11px', display: 'block' }}>Authorized Signatory</strong>
                                <strong style={{ fontSize: '11px' }}>For, {company?.company_name || data?.companyName || 'COMPANY NAME'}</strong>
                            </div>
                        </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ElegantSalesInvoice;
